// As regras vivem em `@workspace/core/auth/redirect` para que web e admin
// decidam igual sobre qualquer `redirectTo`.
export {
  buildLoginPath,
  buildRefreshSessionPath,
  buildSecondFactorPath,
  buildUnauthorisedRedirectPath,
  buildVerifyEmailPath,
  DEFAULT_AUTHENTICATED_PATH,
  getSafeRedirectPath,
  getSafeRedirectTarget,
  isUnauthorisedError,
  LOGIN_PATH,
  REDIRECT_QUERY_PARAM,
  REFRESH_ATTEMPT_COOKIE,
  REFRESH_SESSION_PATH,
  SECOND_FACTOR_PATH,
  VERIFY_EMAIL_PATH,
} from "@workspace/core/auth/redirect";
